import { useEffect, useRef } from 'react';

interface Props {
  lat: number;
  lng: number;
  live?: boolean;
  isOut?: boolean;
}

export const LocationMap = ({ lat, lng, live, isOut }: Props) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<any>(null);
  const markerRef = useRef<any>(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    // Load Leaflet dynamically
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.onload = () => {
      const L = (window as any).L;
      if (!mapRef.current || mapInstanceRef.current) return;

      const map = L.map(mapRef.current, {
        zoomControl: false,
        dragging: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        boxZoom: false,
        keyboard: false,
        attributionControl: false,
      }).setView([lat, lng], 15);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

      const icon = L.divIcon({
        className: '',
        html: `<div style="
          width:28px;height:28px;border-radius:50% 50% 50% 0;
          background:${isOut ? '#7c3aed' : '#22c55e'};
          transform:rotate(-45deg);
          border:3px solid white;
          box-shadow:0 2px 8px rgba(0,0,0,0.3);
          ${live ? 'animation:locPulse 1.5s ease-in-out infinite;' : ''}
        "></div>`,
        iconSize: [28, 28],
        iconAnchor: [14, 28],
      });

      const marker = L.marker([lat, lng], { icon }).addTo(map);
      mapInstanceRef.current = map;
      markerRef.current = marker;
    };
    document.head.appendChild(script);

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
        markerRef.current = null;
      }
    };
  }, []);

  // Update marker position when lat/lng changes (live updates)
  useEffect(() => {
    if (!mapInstanceRef.current || !markerRef.current) return;
    const L = (window as any).L;
    if (!L) return;
    const newLatLng = L.latLng(lat, lng);
    markerRef.current.setLatLng(newLatLng);
    mapInstanceRef.current.setView(newLatLng, 15);
  }, [lat, lng]);

  const openInMaps = () => {
    window.open(`https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}&zoom=15`, '_blank');
  };

  return (
    <div className="location-msg">
      {live && (
        <div className="location-msg__live">
          <span className="location-msg__dot" />
          En vivo
        </div>
      )}
      <div ref={mapRef} className="location-msg__map" />
      <button className="location-msg__open" onClick={openInMaps}>
        📍 Ver en mapa
      </button>
    </div>
  );
};